import { ToolCallProps } from "@/taskpane/types/ToolCall";

type ListDocumentsToolProps = ToolCallProps;

export function ListDocumentsTool({ status }: ListDocumentsToolProps) {
  if (status === "loading") {
    return (
      <div className="flex items-center gap-2 text-sm text-base-content/50 italic">
        <span className="loading loading-spinner loading-xs" />
        <span>Listage des documents...</span>
      </div>
    );
  }

  if (status === "completed") {
    return (
      <div className="flex items-center gap-2 text-sm text-base-content/70 italic">
        <svg
          className="w-4 h-4 flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
        <span>Documents listés</span>
      </div>
    );
  }

  return null;
}
